import React from 'react';

export default function FormError ({ error }) {
    return (
        <span className="form-error">{error}</span>
    );
}